/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Doors_FeeInputs */



/**
* | output |
* | --- |
* | "Entry fee" |
*
* @param {Tournament_Wiz_Doors_FeeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_doors_fee = /** @type {((inputs?: Tournament_Wiz_Doors_FeeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Doors_FeeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Droit d'entrée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuota de inscripción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Taxa de inscrição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Quota d'iscrizione")
	return /** @type {LocalizedString} */ ("Entry fee")
});